import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'GBP',
    maxLists: 10,
};
